module.exports = __webpack_public_path__ + "img/mon_64.95556ed7.png";